import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, Button } from "@material-ui/core";
import { DialogTitle, Transition } from "../../../../utils/DialogTitle";
import { MultiSelect } from "../../../../utils/multiSelect";
import { MultiSelectClientes } from "../../../../utils/multiSelectClientes";
import { useDispatch } from "react-redux";
import { getlisthash, getlistid } from "../../../domain/api/EvbiApi";

export const ModalHandledMachine = ({
    valuecliente,
    listClientes,
    handleselectCliente,
    setopenMondal,
    isOpen,
    reload,
    handledChange,
    value,
    clickCheck,
    stateUser,
    setSelectCliente,
    setselectMachine
}) => {

    const dispatch = useDispatch();
    const rol = stateUser.roles[0].name;
    const [basculas, setbasculas] = useState([])


    const clearData = () => {
        setopenMondal(false);
        reload();
    };


    useEffect(() => {
        if (valuecliente) {
            const fetchData = async () => {
                try {
                    // Traer los datos de las evbis asignadas
                    const asignadas = await getlisthash(dispatch, stateUser.id, "", 0, 30);
                    setSelectCliente(asignadas.content[0].cliente);
                    const id = asignadas.content.map(item => item.id);
                    setselectMachine(id);

                } catch (error) {
                    console.error("Error al consultar API: ", error);
                }
            };

            fetchData();
        }
    }, []);

    useEffect(() => {


        const reload = async () => {
            try {

                const response = await getlistid(dispatch, "", valuecliente, 0, 30)
                setbasculas(response.content)
                if (rol === 'ROLE_CLIENT') {
                    const response = await getlistid(dispatch, "", valuecliente, 0, 30);
                    const ids = response.content.map(item => item.id);
                    handledChange(ids);
                }

            } catch (error) {
                console.error("Error al consultar API: ", error);
            }
        };

        reload();


    }, [valuecliente]);



    return (
        <div>
            <Dialog
                onClose={(e) => {
                    clearData();
                }}
                aria-labelledby="customized-dialog-title"
                open={isOpen}
                TransitionComponent={Transition}
                keepMounted
                style={{ maxHeight: "500%", height: 500 }}
                fullWidth={true}
                maxWidth="xs"
            >
                <DialogTitle id="customized-dialog-title" onClose={(e) => { clearData() }}>
                    Asignar basculas
                </DialogTitle>
                <DialogContent style={{ paddingBottom: "30px", textAlign: "center" }}>
                    {rol !== "ROLE_CLIENT" ? (
                        <>
                            <div style={{ maxWidth: "95%" }}>
                                <MultiSelectClientes
                                    list={listClientes}
                                    handleChange={handleselectCliente}
                                    value={valuecliente}
                                    labelName={"Asignar Cliente"}
                                    disabled={false}
                                />
                            </div>
                            <div style={{ maxWidth: "95%" }}>
                                <MultiSelect
                                    list={basculas}
                                    handleChange={handledChange}
                                    value={value}
                                    labelName={"Asignar Estacion"}
                                    disabled={false}
                                />
                            </div>

                        </>
                    ) : (
                        <>
                            <div style={{ maxWidth: "95%" }}>
                                <MultiSelectClientes
                                    list={listClientes}
                                    handleChange={handleselectCliente}
                                    value={valuecliente}
                                    labelName={"Asignar Cliente"}
                                    disabled={false}
                                />
                            </div>
                        </>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ width: "100%", marginTop: "5px" }}
                        onClick={clickCheck}
                    >
                        Asignar
                    </Button>
                </DialogContent>
            </Dialog>
        </div>
    );
};
